import { NightsOverlapProps, NightsRange, ParsedNightsRange } from './types';

const parseNightsRange = (range: NightsRange): ParsedNightsRange => {
	if (range.startsWith('gte')) {
		return {
			min: Number(range.replace('gte', '')),
			max: Infinity,
		};
	}

	if (range.includes('~')) {
		const [min, max] = range.split('~').map(Number);
		return { min, max };
	}

	const nights = Number(range);
	return {
		min: nights,
		max: nights,
	};
};

export const doNightRangesOverlap = ({ searchRanges, criteriaRanges }: NightsOverlapProps): boolean => {
	if (!criteriaRanges || criteriaRanges?.length === 0) {
		return true;
	}

	for (const searchRange of searchRanges) {
		const { min: searchMin, max: searchMax } = parseNightsRange(searchRange);

		for (const criteriaRange of criteriaRanges) {
			const { min: criteriaMin, max: criteriaMax } = parseNightsRange(criteriaRange);

			if (searchMin <= criteriaMax && searchMax >= criteriaMin) {
				return true;
			}
		}
	}

	return false;
};

export const getNightRangesOverlap = ({ searchRanges, criteriaRanges }: NightsOverlapProps): NightsRange[] => {
	if (!criteriaRanges || criteriaRanges?.length === 0) {
		return searchRanges;
	}

	const newRanges = [];

	for (const searchRange of searchRanges) {
		const { min: searchMin, max: searchMax } = parseNightsRange(searchRange);

		for (const criteriaRange of criteriaRanges) {
			const { min: criteriaMin, max: criteriaMax } = parseNightsRange(criteriaRange);

			if (searchMin <= criteriaMax && searchMax >= criteriaMin) {
				const newRangeMin = Math.max(searchMin, criteriaMin);
				const newRangeMax = Math.min(searchMax, criteriaMax);

				const newRange: NightsRange = newRangeMax === Infinity ? `gte${newRangeMin}` : `${newRangeMin}~${newRangeMax}`;

				newRanges.push(newRange);
			}
		}
	}

	return newRanges;
};
